import { Component, signal, input, output, HostBinding } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { NotificationService } from '../../shared/services/notification.service';
import { ConfirmService } from '../../shared/services/confirm.service';
import { MAIN_MENU } from '../../constants/menu.constants';
import { computed } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  constructor(
    private auth: AuthService,
    private notify: NotificationService,
    private confirm: ConfirmService
  ) {}

  mobileOpen = input(false);
  menuSelected = output<void>();
  isCollapsed = signal(false);
  user = computed(() => this.auth.user());

  menu = computed(() => {
    const user = this.auth.user();
    if (!user) return [];

    return MAIN_MENU.filter((item) => {
      if (!item.roles || item.roles.length === 0) return true;
      return this.auth.hasRole(item.roles);
    });
  });

  @HostBinding('class.mobile-open')
  get isMobileOpen() {
    return this.mobileOpen();
  }

  toggleSidebar() {
    this.isCollapsed.set(!this.isCollapsed());
  }

  async logout() {
    const nombre = this.user()?.name?.split(' ')[0] ?? 'Usuario';

    const ok = await this.confirm.confirm({
      title: 'Cerrar sesión',
      message: `¿Deseas cerrar sesión, ${nombre}?`,
      confirmLabel: 'Cerrar sesión',
      cancelLabel: 'Cancelar',
    });

    if (!ok) return;

    this.auth.logout();

    this.notify.success(`Sesión cerrada correctamente. Hasta pronto, ${nombre}.`);

    window.location.href = '/login';
  }

  onMenuClick() {
    this.menuSelected.emit();
  }
}
